import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { Button } from '../Button/Button';
import { IconChevronDown } from '../Icon/index';

/**
 * A button variant to be used with `DropdownPopper`.
 *
 * @extends Button
 * @related [`DropdownIcon`, `DropdownPopper`]
 * @since 7.28.0
 */
var DropdownButton = /*#__PURE__*/styled(Button).withConfig({
  displayName: "DropdownButton",
  componentId: "c11n-8-111-1__sc-1nhw8sf-0"
})([""]);
DropdownButton.displayName = 'DropdownButton';
DropdownButton.propTypes = {
  /**
   * The button content.
   */
  children: PropTypes.node.isRequired,
  /**
   * @ignore
   */
  icon: PropTypes.node,
  /**
   * @ignore
   */
  iconPosition: PropTypes.string,
  /**
   * @ignore
   */
  iconSize: PropTypes.string
};
DropdownButton.defaultProps = {
  icon: /*#__PURE__*/React.createElement(IconChevronDown, null),
  iconPosition: 'end',
  iconSize: 'xs'
};

/** @component */
export { DropdownButton };